import { Fragment } from "react";
import type { ProviderType } from "@wags/catalog/pure.ts";
import { VerifiedProviderBadge } from "@/components/shared/VerifiedProviderBadge";

export function ProviderVerifiedName({
    name,
    isVerified,
    providerType,
}: {
    name: string;
    isVerified?: boolean;
    providerType: ProviderType;
}) {
    const trimmedName = name.trimEnd();
    const lastSpace = trimmedName.lastIndexOf(" ");
    const prefix = isVerified ? trimmedName.slice(0, lastSpace + 1) : name;
    const lastWord = trimmedName.slice(lastSpace + 1);

    return (
        <>
            {prefix.split(/(?<=[.&])/u).map((part, index) => (
                <Fragment key={`${index}:${part}`}>
                    {index > 0 && <wbr />}
                    {part}
                </Fragment>
            ))}
            {isVerified && (
                <span className="inline-block max-w-full align-baseline">
                    <span className="break-all">{lastWord}</span>
                    <VerifiedProviderBadge
                        isVerified={isVerified}
                        providerType={providerType}
                        interactive
                    />
                </span>
            )}
        </>
    );
}
